import {SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {SPECS} from '../specs';

export function hackInitializeViewerScriptForPreviewBecausePreviewIsInIframe(
  siteStore: SiteStore,
  viewerContext: ViewerContext
) {
  const moveCartToViewerContext = viewerContext.isExperimentEnabled(SPECS.MoveCartToViewerContext);
  const previewMode = moveCartToViewerContext ? viewerContext.getViewMode() === 'Preview' : siteStore.isPreviewMode();

  if (previewMode) {
    return loadEcomPlatformViewerScriptIfNotLoadedYet(viewerContext);
  }
}

function loadEcomPlatformViewerScriptIfNotLoadedYet(viewerContext: ViewerContext) {
  return viewerContext.getEcomPlatformPublicAPI();
}
